import React from "react"
import classnames from "classnames"
import styles from "./BookTestDrive.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import urlHandler from "AtomicUtils/urlHandler"
import { Section, Content, InputText, Space, InputCheckBox, A, Button, InputSelect, H3, H5, FormGroup, InputEmail, InputRadio, P } from "AtomicComponents"
import { AlertList, DealerSearch } from "AtomicContainers"
import InputSearchable from "../InputSearchable/InputSearchable"
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formLinkSubmit, formSetDefaultValues } from "AtomicUtils/formHandler"
import componentParser from "AtomicUtils/componentParser"
import { WINDOW } from "constants/environment"
import MESSAGES from "AtomicConstants/MESSAGES"
import TITLES from "./TITLES"
import { DealerSearchBoxNZ } from "components"

class BookTestDrive extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        title: {
          validations: {
            required: MESSAGES.TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: MESSAGES.FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: MESSAGES.LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: MESSAGES.PHONE_NUMBER_REQUIRED,
            phone: MESSAGES.PHONE_NUMBER_INVALID
          }
        },
        email: {
          validations: {
            required: MESSAGES.EMAIL_REQUIRED,
            email: MESSAGES.EMAIL_INVALID
          }
        },
        model: {
          validations: {
            required: MESSAGES.MODEL_REQUIRED
          }
        },
        region: {
          validations: {

          }
        },
        dealer: {
          validations: {
            required: MESSAGES.DEALERS_REQUIRED
          }
        },
        comments: {
          validations: {
          }
        },
        finance: {
          validations: {
          }
        },
        privacy: {
          validations: {
            required: MESSAGES.PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    }
  }

  componentDidMount() {
    const { models, initialLocations } = this.props
    const currentURL = new urlHandler(WINDOW.location.href)

    // Handling pre-selecting models
    if (currentURL.query.model) {
      const queryModel = currentURL.query.model
      const model = models.find(item => item.name.split(/[^a-zA-Z0-9]+/).join('-').toLowerCase() === queryModel)

      if (model && model.value) {
        formSetDefaultValues(this, {
          model: String(model.value)
        })
      }
    }

    if (initialLocations && initialLocations[0] && initialLocations[0].postCode) {
      formSetDefaultValues(this, {
        region: initialLocations[0].postCode
      })
    }
  }

  _handleSubmit = async (event) => {
    const { financeOptionText, buttonText = "Book your test drive" } = this.props
    if (event) event.preventDefault()
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { submitFormEndPoint } = this.props
        const { form } = this.state

        let body = {
          title: form.title.value,
          firstName: form.firstName.value,
          lastName: form.lastName.value,
          phone: form.phone.value,
          email: form.email.value,
          nameplate: form.model.value,
          dealerLocation: form.dealer.value.id,
          dealerCode: form.dealer.value.dealerCode,
          postCode: form.dealer.value.postCode,
          suburb: form.dealer.value.suburb,
          state: form.dealer.value.state,
          financeInterest: financeOptionText ? (form.finance.value === true ? 'Yes' : null) : undefined,
          comments: form.comments.value || null
        }

        await fetchAPI({
          method: "POST",
          url: submitFormEndPoint,
          body: body
        })
          .then(async (response) => {
            const json = await response.json()
            const { success, errorMsg } = json
            if (!success) {
              this.setState({
                errorMessage: errorMsg,
                loading: false
              })
            } else {
              // successful
              this.setState({
                loading: false,
                success: true
              }, () => {
                gtmHandler({
                  pageCategory: "Book A Test Drive Form",
                  pageAction: `Book A Test Drive Form - Clicked "${buttonText.toUpperCase()}"`
                })
                gtmHandler({
                  pageCategory: "Book A Test Drive Form",
                  pageAction: `Book A Test Drive Form - Clicked Submitted - "${form.model.value}"`
                })
              })
            }
          })
          .catch((response) => {
            this.setState({
              errorMessage: response.message || `Failed with status ${response.status}`,
              loading: false
            })
          })
      })
    }
  }

  _handleOnBlurSearchableRegion = (value) => {
    if (value && value.display) {
      gtmHandler({
        pageCategory: "Book A Test Drive Form",
        pageAction: `Book A Test Drive Form - Selected "DEALER" - "${value.display.toUpperCase()}"`
      })
    }

    if (value && value.description) {
      gtmHandler({
        pageCategory: "Book A Test Drive Form",
        pageAction: `Book A Test Drive Form - Selected "POSTCODE/SUBURB" - "${value.description.toUpperCase()}"`
      })
    }
  }

  selectDealer = (dealer) => {
    // no search, use the selected dealer only for the radio inputs
    // this.refs.dealerSearchComp._search(dealer.postCode, dealer.dealerCode)
    this.refs.dealerSearchComp.setState({
      dealers: [dealer],
      selected: dealer,
      loading: false
    })
  }

  render() {
    const {
      title, introText, models, privacyPolicy, privacyPolicyLink, dealersEndPoint = "/api/dealer-search", dealerSearchEndPoint, buttonText = "Book your test drive", initialLocations = [], financeOptionText, thankYouComponents
    } = this.props
    const { loading, form, success, errorMessage } = this.state

    if (success) {
      return componentParser(thankYouComponents)
    }

    return (
      <Section padding>
        <div className={classnames({
          [styles.BookTestDrive]: true
        })}>
          <H3 withDetails>{title}</H3>
          <Content xmlString={introText} />
          <div className={classnames({
            [styles.BookTestDriveForm]: true
          })}>
            <form method="POST" onSubmit={this._handleSubmit} noValidate>
              <FormGroup center>
                <H5>CHOOSE YOUR MAZDA</H5>
              </FormGroup>
              <FormGroup>
                <InputSelect
                  name="model"
                  label="Model"
                  options={models.map(({ name, value }) => ({ label: name, value }))}
                  {...fromLinkInputs(this, "model")}
                  onBlur={()=>{
                    form.model.value &&
                    gtmHandler({
                      pageCategory: "Book A Test Drive Form",
                      pageAction: `Book A Test Drive Form - Selected "MODEL" - "${form.model.value.toUpperCase()}"`
                    })
                  }}
                />
              </FormGroup>
              <FormGroup center>
                <H5>ENTER YOUR DETAILS</H5>
              </FormGroup>
              <FormGroup>
                <InputSelect
                  name="title"
                  label="Title"
                  options={TITLES}
                  {...fromLinkInputs(this, "title")}
                  onBlur={()=>{
                    if (form.title.value) {
                      gtmHandler({
                        pageCategory: "Book A Test Drive Form",
                        pageAction: `Book A Test Drive Form - Selected "TITLE" - "${form.title.value.toUpperCase()}"`
                      })
                    }
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputText
                  name="firstName"
                  label="First Name"
                  {...fromLinkInputs(this, "firstName")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Book A Test Drive Form",
                      pageAction: "Book A Test Drive Form - Entered \"FIRSTNAME\""
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputText
                  name="lastName"
                  label="Last Name"
                  {...fromLinkInputs(this, "lastName")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Book A Test Drive Form",
                      pageAction: "Book A Test Drive Form - Entered \"LASTNAME\""
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputText
                  name="phone"
                  label="Phone"
                  {...fromLinkInputs(this, "phone")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Book A Test Drive Form",
                      pageAction: "Book A Test Drive Form - Entered \"PHONE\""
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputEmail
                  name="email"
                  label="Email"
                  {...fromLinkInputs(this, "email")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Book A Test Drive Form",
                      pageAction: "Book A Test Drive Form - Entered \"EMAIL\""
                    })
                  }}
                />
              </FormGroup>
              {/* <FormGroup>
                <InputSearchable
                  name="region"
                  type="dealer"
                  dealersEndPoint={dealersEndPoint}
                  label="Enter your postcode, suburb or Dealer name"
                  {...fromLinkInputs(this, "region")}
                  onBlur={this._handleOnBlurSearchableRegion}
                />
              </FormGroup> */}

              <H5 textAlign="center">Find a dealer</H5>
              <P>Select your region and we'll give you a list of your local Mazda Dealerships.</P>

              <DealerSearchBoxNZ
                searchType="SALES"
                noMap={true}
                selectDealerVariant={true}
                selectDealer={this.selectDealer}
              />
              <FormGroup>
                <DealerSearch
                  dealersEndPoint={dealersEndPoint}
                  endpoint={dealerSearchEndPoint}
                  disabled={!form.region.value || !(form.region.value.postcode || form.region.value.value)}
                  type="Sales"
                  name="dealer"
                  postcode={form.region.value && form.region.value.postcode || (initialLocations && initialLocations[0] && initialLocations[0].postCode)}
                  dealerCode={form.region.value && form.region.value.value}
                  ref="dealerSearchComp"
                  {...fromLinkInputs(this, "dealer")} />
              </FormGroup>
              <FormGroup>
                <InputText
                  name="comments"
                  label="Tell us your enquiry"
                  {...fromLinkInputs(this, "comments")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Book A Test Drive Form",
                      pageAction: "Book A Test Drive Form - Entered \"ENQUIRY\""
                    })
                  }}
                />
              </FormGroup>
              {
                financeOptionText &&
                <FormGroup show checkbox>
                  <InputCheckBox
                    name="finance"
                    label={financeOptionText}
                    {...fromLinkInputs(this, "finance", (value) => {
                      gtmHandler({
                        pageCategory: "Book A Test Drive Form",
                        pageAction: `Book A Test Drive Form - ${value ? 'Checked' : 'Unchecked'} \"FINANCE\"`
                      })
                    })}
                  />
                </FormGroup>
              }
              {
                financeOptionText &&
                <FormGroup show checkbox>
                  <hr style={{ height: "1px", width: "100%", border: "0", borderTop: "1px solid #D5D5D5" }} />
                </FormGroup>
              }
              {!financeOptionText && <Space />}
              <Space />
              <FormGroup show checkbox>
                <InputCheckBox
                  name="privacy"
                  label={
                    <span>
                      {privacyPolicy}{" "}
                      <A
                        href={privacyPolicyLink}
                        onClick={()=>{
                          gtmHandler({
                            pageCategory: "Book A Test Drive Form",
                            pageAction: "Book A Test Drive Form - Clicked \"PRIVACYPOLICY\""
                          })
                        }}
                        external>
                          <nobr>Privacy Policy</nobr>
                      </A>
                    </span>
                  }
                  {...fromLinkInputs(this, "privacy", (value) => {
                    gtmHandler({
                      pageCategory: "Book A Test Drive Form",
                      pageAction: `Book A Test Drive Form - ${value ? 'Checked' : 'Unchecked'} \"PRIVACYPOLICY\"`
                    })
                  })}
                />
              </FormGroup>
              <Space />
              <Space />
              <FormGroup>
                <AlertList data={errorMessage} />
                <Button
                  styleName="black"
                  loading={loading}
                  fullWidth
                  {...formLinkSubmit(this, this._handleSubmit)}
                >
                  {buttonText}
                </Button>
              </FormGroup>

            </form>
          </div>
        </div>
      </Section>
    )
  }
}

export default BookTestDrive



// WEBPACK FOOTER //
// ./src/AtomicContainers/BookTestDrive/BookTestDrive.jsx